/* ============================================================
   BarklyPaw GLOBAL - Buy 1 Get 1 cart logic (up to two deals per
   order, Ram 2026-07-01). The buy-box ATC adds exactly ONE SET =
   2 mats of one SIZE (same colour -> qty 2 of one variant; two
   colours -> 1 of each), the second mat free via the automatic
   per-size BOGO discount. Up to TWO SETS may exist in the cart, so
   a customer can buy the deal twice. No quantity editing on mat
   lines; the self-heal below collapses any drift back to two sets.
   Per-size mat count must stay EVEN (a set is 2 mats).
   Also: countdown timers, sticky mobile CTA, and the Pelsbarn-shaped
   cart drawer (urgency clock, delivery ETA, upsell rail).

   2026-09-02: the second-1+1-set cart upsell handler (wireUpsell /
   observeCartUpsell / UP_COLORS, driven by snippets/bp-cart-second-set.liquid)
   was REMOVED. That snippet has not been rendered since 2026-08-31, when Ram
   pulled the "20% off 4 mats" discount out of the cart, so the code was dead.
   The drawer's own upsell rail (Disco / Tug ball) replaces it.
   ============================================================ */
(function () {
  'use strict';
  window.BarklyPaw = window.BarklyPaw || {};
  var BP = window.BarklyPaw;

/* Localised copy is injected by layout/theme.liquid as window.BP_I18N. This file is a
   static .js asset so it cannot use Liquid's `t` filter; T() reads the global and falls
   back to the original English, so a missing key degrades instead of printing "undefined". */
function T(key, fallback){
  var d = window.BP_I18N || {};
  return (typeof d[key] === 'string' && d[key]) ? d[key] : fallback;
}
  var BUNDLE_QTY = 2; /* a Buy 1 Get 1 set = 2 mats of one size */
  var MAX_BUNDLE_SETS = 2;
  var MAX_BUNDLE_MATS = BUNDLE_QTY * MAX_BUNDLE_SETS;
  /* Mystery gift: every mat order carries one Nub ball, made $0 by the automatic Basic
     discount DiscountAutomaticNode/1801323643197. It rides along with the first set, is
     never counted as a mat, and is masked as a mystery in the cart and on /cart. */
  var MYSTERY_VARIANT = 52904279900477;
  var MYSTERY_PRODUCT = 10476362137917;
  var MAT_PRODUCT = 10438284247357;
  var MAT_HANDLE = 'barklypaw-cooling-mat-1plus1';
  function cartHasMystery(cart){ return (cart && cart.items || []).some(function(it){ return String(it.variant_id)===String(MYSTERY_VARIANT); }); }
  function cartMysteryQty(cart){ return (cart && cart.items || []).reduce(function(n,it){ return n + (String(it.variant_id)===String(MYSTERY_VARIANT) ? (it.quantity||0) : 0); }, 0); }
  /* one Mystery Gift per 1+1 set (Ram 2026-10-29) */
  function mysteryFor(mats){ return mats > 0 ? Math.max(1, Math.floor(mats / BUNDLE_QTY)) : 0; }

  /* Only the cooling mat is part of the BOGO bundle arithmetic. The mystery gift
     and any drawer upsell (Disco ball, Tug ball) are ordinary lines: they must
     never be counted as mats, parity-trimmed or dropped by the self-heal.
     (2026-09-02: before this, every non-gift line was treated as an XL mat.) */
  function isMatItem(it) {
    if (!it) return false;
    if (String(it.product_id) === String(MAT_PRODUCT)) return true;
    return String(it.handle || '') === MAT_HANDLE;
  }
  function sizeFromText(t) {
    var m = String(t || '').match(/\b(XS|XL|S|M|L)\b/);
    return m ? m[1] : null;
  }
  /* NOTE: the automatic BOGO discount SPLITS a set into two cart lines
     (paid + free), so cost must be computed per VARIANT TOTAL, never
     per line (verified live 2026-06-12). */
  function variantTotals(cart) {
    var byV = {};
    (cart && cart.items || []).forEach(function (it) {
      if (!isMatItem(it)) return; /* gift + upsells are not mats */
      var k = String(it.variant_id);
      if (!byV[k]) byV[k] = { qty: 0, size: sizeFromText(it.variant_title || it.title || '') };
      byV[k].qty += (it.quantity || 0);
    });
    return byV;
  }
  /* mat variant ids in cart order - the only keys variantTotals() knows about */
  function matOrder(cart) {
    var order = [];
    (cart && cart.items || []).forEach(function (it) {
      if (!isMatItem(it)) return;
      var k = String(it.variant_id);
      if (order.indexOf(k) < 0) order.push(k);
    });
    return order;
  }
  function cartMatCount(cart) {
    var byV = variantTotals(cart);
    return Object.keys(byV).reduce(function (sum, k) {
      return sum + (byV[k].qty || 0);
    }, 0);
  }
  /* ---- money helper: "$79" in the US market; every other currency in its own symbol + ISO code, e.g. "$112 AUD",
     "€69.95 EUR", "£60 GBP", "¥12,400 JPY", "AED 295" (2026-09-08: local currencies live in every market;
     Shopify.currency.active is whatever the visitor's market resolved to) ---- */
  BP.money = function (cents) {
    var n = (Number(cents) / 100);
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var s;
    try {
      s = new Intl.NumberFormat(cur === 'EUR' ? 'fr-FR' : 'en-US', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(n);
    } catch (e) {
      s = '$' + n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    }
    if (cur !== 'USD' && cur !== 'INR' && cur !== 'EUR' && s.indexOf(cur) < 0) s += ' ' + cur;
    return s;
  };

  /* a BOGO SET = two mats of the SAME SIZE. Same color -> qty 2 of one variant;
     two colors -> 1 of each (the per-size automatic discount frees one of the
     pair, regardless of color). Both mats are the same size, so the set cost and
     the discount are identical either way. */
  function bundleItems(v1, v2) {
    if (v2 && String(v2) !== String(v1)) {
      return [{ id: Number(v1), quantity: 1 }, { id: Number(v2), quantity: 1 }];
    }
    /* Same colour = two quantity-1 lines; the hidden _bp_unit property stops Shopify merging
       them. One quantity-2 line made Meta flag the AddToCart browser and server values as
       mismatched (Events Manager diagnostics, 2026-10-26): the Facebook app's browser event
       sends one unit's price. BOGO discount, cart and checkout totals are unchanged. */
    return [{ id: Number(v1), quantity: 1 }, { id: Number(v1), quantity: 1, properties: { _bp_unit: '2' } }];
  }
  BP.bundleItems = bundleItems;

  /* Kept for callers that explicitly need a one-set link; never used for recovery. */
  var BP_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function bundleCartUrl(v1, v2) {
    if (v2 && String(v2) !== String(v1)) {
      return BP_ROOT + 'cart/' + encodeURIComponent(String(v1)) + ':1,' + encodeURIComponent(String(v2)) + ':1?storefront=true';
    }
    return BP_ROOT + 'cart/' + encodeURIComponent(String(v1)) + ':' + BUNDLE_QTY + '?storefront=true';
  }
  BP.bundleCartUrl = bundleCartUrl;

  /* ---- lightweight toast ---- */
  BP.flash = function (msg) {
    var t = document.createElement('div');
    t.textContent = msg;
    t.style.cssText = 'position:fixed;inset-inline:0;bottom:20px;margin:0 auto;max-width:340px;' +
      'background:#382e2e;color:#fff;padding:13px 18px;border-radius:12px;text-align:center;' +
      'font-weight:700;z-index:9999;box-shadow:0 10px 30px rgba(0,0,0,.3);font-family:Assistant,sans-serif';
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 3200);
  };

  /* ---- skeleton helper ----
     Build a "what you just added" card from local variant data and
     inject it into the drawer BEFORE the API confirms. The user sees
     the exact product/size/color/price they picked instead of a blank
     spinner. drawer.renderContents() will wipe the skeleton when the
     real cart HTML lands (it replaces innerHTML of the section). */
  function buildSkeletonHTML(variantId) {
    var variantsEl = document.querySelector('[data-bp-variants]');
    if (!variantsEl) return '';
    var variants;
    try { variants = JSON.parse(variantsEl.textContent || '[]'); } catch (e) { return ''; }
    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) { v = variants[i]; break; }
    }
    if (!v) return '';
    /* image: prefer variant featured_image, else active hero slide, else any product image */
    var img = '';
    if (v.featured_image && v.featured_image.src) img = v.featured_image.src;
    if (!img) {
      var heroImg = document.querySelector('.bp-gal-slide.is-active img') ||
                    document.querySelector('.bp-gal-slide img');
      if (heroImg) img = heroImg.currentSrc || heroImg.src || '';
    }
    /* price for the cart = single mat (2nd is free via the BOGO discount) */
    var priceCents = Number(v.price) || 0;
    var priceTxt = BP.money(priceCents);
    var variantTitle = (v.title || '').replace(' / ', ' · ');
    var safeImg = String(img).replace(/"/g, '%22');
    var safeTitle = (variantTitle + '').replace(/[<>]/g, '');
    return '<div class="bp-cart-skeleton" aria-hidden="true">' +
      '<div class="bp-skel-card">' +
        '<div class="bp-skel-img">' + (safeImg ? '<img src="' + safeImg + '" alt="" loading="eager">' : '') + '</div>' +
        '<div class="bp-skel-meta">' +
          '<div class="bp-skel-title">' + T('skel_title','BarklyPaw Cooling Mat') + '</div>' +
          '<div class="bp-skel-variant">' + safeTitle + '</div>' +
          '<div class="bp-skel-bogo">' + T('skel_bogo','2 mats · second one free') + '</div>' +
        '</div>' +
        '<div class="bp-skel-price">' + priceTxt + '</div>' +
      '</div>' +
      '<div class="bp-skel-loading"><span class="bp-skel-dot"></span><span class="bp-skel-dot"></span><span class="bp-skel-dot"></span></div>' +
    '</div>';
  }

  /* Shared state avoids a cart GET when the server-rendered snapshot is fresh.
     Each writer holds the same lock until its returned sections are confirmed. */
  function cartSections() {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.dataset.id && ids.indexOf(el.dataset.id) < 0) ids.push(el.dataset.id);
    });
    return ids.join(',');
  }
  function postCart(path, body) {
    return fetch(BP_ROOT + path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign({ sections: cartSections(), sections_url: window.location.pathname }, body))
    }).then(function (r) {
      BP.cartState.invalidate();
      return r.json().then(function (res) {
        if (!r.ok || !res || (res.status && Number(res.status) >= 400)) {
          throw new Error((res && res.description) || 'Could not update your cart.');
        }
        return res;
      });
    });
  }
  function renderCart(res) {
    var replacements = [];
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || !el.dataset.id) return;
      var sid = el.dataset.id, html = res.sections && res.sections[sid];
      var current = document.getElementById('shopify-section-' + sid);
      var doc = html && new DOMParser().parseFromString(html, 'text/html');
      var next = doc && doc.getElementById('shopify-section-' + sid);
      if (!current || !next) throw new Error('Please reload your cart to confirm the total.');
      replacements.push({ current: current, next: next });
    });
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      if (typeof window.bpRenderCart === 'function') window.bpRenderCart(res);
      else if (res.sections && res.sections['cart-drawer'] && typeof drawer.renderContents === 'function') drawer.renderContents(res);
      else throw new Error('Please reload your cart to confirm the total.');
    } else {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var bubbleHTML = res.sections && res.sections['cart-icon-bubble'];
        var bubbleDoc = bubbleHTML && new DOMParser().parseFromString(bubbleHTML, 'text/html');
        var nextBubble = bubbleDoc && bubbleDoc.querySelector('.shopify-section');
        if (!nextBubble) throw new Error('Please reload your cart to confirm the total.');
        bubble.innerHTML = nextBubble.innerHTML;
      }
    }
    replacements.forEach(function (part) { part.current.innerHTML = part.next.innerHTML; });
    paintCartTimer();
    paintDeliveryEta();
    if (!drawer && !replacements.length) window.location.href = BP_ROOT + 'cart';
  }
  function recoverCart(err) {
    BP.cartState.invalidate();
    return BP.cartState.recover().then(function () {
      if (!document.getElementById('main-cart-items')) return;
      // The drawer recovery is shared; the full cart needs its own sections too.
      return fetch(BP_ROOT + 'cart?sections=' + encodeURIComponent(cartSections()), {
        credentials: 'same-origin', headers: { 'Accept': 'text/html' }
      }).then(function (r) {
        if (!r.ok) throw new Error('Please reload your cart to confirm the total.');
        return r.json();
      }).then(function (sections) { renderCart({ sections: sections }); });
    }).then(function () {
      BP.flash((err && err.message) || 'Your cart was refreshed. Please check it before trying again.');
    }).catch(function () {
      var checkout = document.getElementById('checkout');
      if (checkout) checkout.disabled = true;
      BP.flash('We could not confirm the update. Please reload your cart before checkout.');
    });
  }
  /* Convert corrected variant totals to existing line keys, preserving properties,
     discounts and ordinary products. Discount-split paid/free lines have unique keys. */
  function matLineUpdates(cart, byV) {
    var remaining = {}, updates = {};
    Object.keys(byV).forEach(function (k) { remaining[k] = Math.max(0, byV[k].qty || 0); });
    var hasMats = Object.keys(remaining).some(function (k) { return remaining[k] > 0; });
    var gifts = mysteryFor(Object.keys(remaining).reduce(function (n, k) { return n + remaining[k]; }, 0));
    (cart.items || []).forEach(function (it) {
      if (isMatItem(it)) {
        if (!it.key) throw new Error('Your cart changed. Please reopen it and try again.');
        var k = String(it.variant_id), qty = Math.min(it.quantity || 0, remaining[k] || 0);
        remaining[k] = Math.max(0, (remaining[k] || 0) - qty);
        updates[it.key] = qty;
      } else if (String(it.product_id) === String(MYSTERY_PRODUCT)) {
        if (!it.key) throw new Error('Your cart changed. Please reopen it and try again.');
        /* one gift per set: the first gift line carries them all, any other gift line is cleared */
        updates[it.key] = hasMats ? gifts : 0; gifts = 0;
      }
    });
    return updates;
  }

  /* ---- bundle add-to-cart ----
     One add request carries both mats, the first gift and Shopify-rendered totals.
     An uncertain response is recovered by reading the cart, never by adding again. */
  BP.addBundle = function (variantId, btn, variantId2) {
    if (!variantId) {
      BP.flash(T('pick_first','Choose a color and size first'));
      return;
    }
    if (!BP.cartState || !BP.cartState.begin()) return;
    if (btn) { btn.disabled = true; btn.classList.add('bp-loading'); }
    var drawer = document.querySelector('cart-drawer');
    function reEnable() {
      if (btn) { btn.disabled = false; btn.classList.remove('bp-loading'); }
      if (drawer) {
        drawer.classList.remove('bp-cart-busy');
        drawer.classList.remove('bp-cart-skeleton-shown');
        var skel = drawer.querySelector('.bp-cart-skeleton');
        if (skel) skel.remove();
      }
      BP.cartState.end();
    }
    // Immediate feedback while Shopify confirms the real cart and discounts.
    if (drawer && typeof drawer.open === 'function') {
      drawer.classList.add('bp-cart-busy');
      var inner = drawer.querySelector('.drawer__inner');
      var skel = buildSkeletonHTML(variantId);
      if (inner && skel) {
        var prev = inner.querySelector('.bp-cart-skeleton');
        if (prev) prev.remove();
        inner.insertAdjacentHTML('afterbegin', skel);
        drawer.classList.add('bp-cart-skeleton-shown');
      }
      try { drawer.open(); } catch (e) {}
    }
    return BP.cartState.read().then(function (cart) {
      if (cartMatCount(cart) + BUNDLE_QTY > MAX_BUNDLE_MATS) {
        BP.flash(T('max_sets','You can add up to two sets per order'));
        return null;
      }
      var items = bundleItems(variantId, variantId2);
      var wantGifts = mysteryFor(cartMatCount(cart) + BUNDLE_QTY), haveGifts = cartMysteryQty(cart);
      if (wantGifts > haveGifts) items.push({ id: MYSTERY_VARIANT, quantity: wantGifts - haveGifts });
      return postCart('cart/add.js', { items: items });
    }).then(function (res) {
      if (!res) return;
      restartCartTimer();
      renderCart(res);
    }).catch(recoverCart).finally(reEnable);
  };

  /* ---- secondary CTAs: smooth-scroll to the buy box ----
     Any link pointing at #bp-buy brings the visitor to the buy box so
     they pick size/color there. It must never jump to the cart. */
  /* secondary "#bp-buy" links scroll to the buy box natively: the id is on
     the hero .bp-wrap (a real laid-out element) with scroll-margin-top in
     CSS. No JS needed - the browser handles the scroll reliably. */

  /* ---- countdown timers (any [data-bp-countdown] element) ----
     HONEST shipping-cutoff timer (Ram, 2026-06-13, replacing the old per-visitor
     evergreen reset). The element carries data-bp-cutoff-hour="14" = the real
     daily dispatch cutoff. The clock counts down to today's cutoff; once it
     passes, it rolls to tomorrow's cutoff and flips the "ships today/tomorrow"
     label. No fake offer-deadline, nothing resets mid-session - the urgency is a
     genuine, verifiable shipping promise (defensible on Meta + consumer law).
     Each element may set data-bp-timezone so every visitor sees the same business
     deadline regardless of their device timezone. */
  function initCountdowns() {
    var els = document.querySelectorAll('[data-bp-countdown]');
    if (!els.length) return;

    var WDAY = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    // "now" as wall-clock parts in the element's business timezone.
    function zonedNow(timeZone) {
      try {
        var p = new Intl.DateTimeFormat('en-US', {
          timeZone: timeZone || 'Asia/Jerusalem', hour12: false, weekday: 'short',
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit'
        }).formatToParts(new Date()).reduce(function (a, x) { a[x.type] = x.value; return a; }, {});
        var hh = +p.hour === 24 ? 0 : +p.hour;
        return { secs: hh * 3600 + (+p.minute) * 60 + (+p.second), wd: WDAY[p.weekday], day: p.year + p.month + p.day };
      } catch (e) {
        var d = new Date();
        return { secs: d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds(), wd: d.getDay(), day: 'x' };
      }
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function paint(el, total) { // total = seconds remaining
      var dd = Math.floor(total / 86400), hh = Math.floor((total % 86400) / 3600),
          mm = Math.floor((total % 3600) / 60), ss = total % 60;
      var D = el.querySelector('[data-d]'), H = el.querySelector('[data-h]'),
          M = el.querySelector('[data-m]'), S = el.querySelector('[data-s]');
      if (D) D.textContent = pad(dd);
      var dwraps = el.querySelectorAll('[data-d-wrap]');
      for (var i = 0; i < dwraps.length; i++) dwraps[i].toggleAttribute('hidden', dd <= 0);
      if (H) H.textContent = pad(hh);
      if (M) M.textContent = pad(mm);
      if (S) S.textContent = pad(ss);
    }

    function tick() {
      els.forEach(function (el) {
        var t = zonedNow(el.getAttribute('data-bp-timezone') || 'Asia/Jerusalem');
        var H = el.querySelector('[data-h]'), M = el.querySelector('[data-m]'), S = el.querySelector('[data-s]');
        var D = el.querySelector('[data-d]');

        // MODE E: evergreen per-browser urgency window (Ram, 2026-06-13).
        // data-bp-evergreen-sec     = countdown length in seconds (2916 = 48m36s).
        // data-bp-evergreen-hold-sec = how long it sits at 00:00 after expiring
        //   before a fresh window starts (default 3 days = 259200).
        // The deadline is persisted per browser in localStorage and is NOT reset on
        // refresh - a returning visitor keeps counting down from where they were.
        // Once it hits zero it HOLDS at 00:00 for the hold period, then starts a fresh
        // window. Renders HH:MM:SS (hours : minutes : seconds; only the days box is
        // hidden, so the hours box shows 00 for a sub-hour window). The offer itself
        // is permanent - this is an urgency timer, Ram's explicit choice.
        var evgSec = parseInt(el.getAttribute('data-bp-evergreen-sec'), 10);
        if (!isNaN(evgSec) && evgSec > 0) {
          var holdSec = parseInt(el.getAttribute('data-bp-evergreen-hold-sec'), 10);
          if (isNaN(holdSec) || holdSec < 0) holdSec = 259200; // 3 days
          var ekey = 'bpEvg:' + (el.getAttribute('data-bp-evergreen-key') || evgSec);
          var enow = Date.now();
          var edl;
          try { edl = parseInt(localStorage.getItem(ekey), 10); } catch (e) { edl = NaN; }
          if (isNaN(edl) || enow >= edl + holdSec * 1000) {
            // first visit, or the 00:00 hold period has fully elapsed → fresh window
            edl = enow + evgSec * 1000;
            try { localStorage.setItem(ekey, String(edl)); } catch (e) {}
          }
          // else: still counting down (enow < edl), or inside the 00:00 hold
          // (edl <= enow < edl + hold) - keep the stored deadline untouched so a
          // refresh never restarts the clock.
          var ediff = Math.floor((edl - enow) / 1000);
          if (ediff < 0) ediff = 0; // hold period shows 00:00:00
          var ehh = Math.floor(ediff / 3600);        // hours (00 for a sub-hour window)
          var emm = Math.floor((ediff % 3600) / 60);  // minutes
          var ess = ediff % 60;                       // seconds
          var ehid = el.querySelectorAll('[data-d-wrap]'); // hide only days; hours box stays (00)
          for (var ei = 0; ei < ehid.length; ei++) ehid[ei].setAttribute('hidden', '');
          if (D) D.textContent = '00';
          if (H) H.textContent = pad(ehh);
          if (M) M.textContent = pad(emm);
          if (S) S.textContent = pad(ess);
          el.removeAttribute('hidden');
          return;
        }

        // MODE 0: weekly recurring deadline (Ram, 2026-06-13). data-bp-weekly-day
        // (0=Sun..5=Fri) + data-bp-weekly-hour. Counts to the next occurrence in
        // the element's business timezone and auto-restarts each week. The offer
        // itself is permanent - this is a weekly urgency timer, by Ram's choice.
        var wDay = parseInt(el.getAttribute('data-bp-weekly-day'), 10);
        var wHour = parseInt(el.getAttribute('data-bp-weekly-hour'), 10);
        if (!isNaN(wDay) && !isNaN(wHour)) {
          var daysUntil = (wDay - t.wd + 7) % 7;
          var total = daysUntil * 86400 + wHour * 3600 - t.secs;
          if (total <= 0) total += 7 * 86400;
          el.removeAttribute('hidden');
          paint(el, total);
          return;
        }

        // MODE 1: real offer-expiry deadline. data-bp-deadline = epoch ms
        // of the actual Shopify discount endsAt. Honest because the offer truly
        // expires then; when it passes, hide the urgency (no fake reset).
        var deadline = parseInt(el.getAttribute('data-bp-deadline'), 10);
        if (!isNaN(deadline) && deadline > 0) {
          var diff = Math.floor((deadline - Date.now()) / 1000);
          if (diff <= 0) { el.setAttribute('hidden', ''); return; }
          el.removeAttribute('hidden');
          var dd = Math.floor(diff / 86400);
          var hh = Math.floor((diff % 86400) / 3600);
          var mm = Math.floor((diff % 3600) / 60);
          var ss = diff % 60;
          if (D) D.textContent = pad(dd);
          var dwraps = el.querySelectorAll('[data-d-wrap]');
          for (var i = 0; i < dwraps.length; i++) dwraps[i].toggleAttribute('hidden', dd <= 0);
          if (H) H.textContent = pad(hh);
          if (M) M.textContent = pad(mm);
          if (S) S.textContent = pad(ss);
          return;
        }

        // MODE 2: daily shipping cutoff (data-bp-cutoff-hour)
        var cutoffH = parseInt(el.getAttribute('data-bp-cutoff-hour'), 10);
        if (isNaN(cutoffH)) cutoffH = 14;
        var cutoffSecs = cutoffH * 3600;
        var beforeCutoff = t.secs < cutoffSecs;
        var remain = beforeCutoff ? (cutoffSecs - t.secs) : (86400 - t.secs + cutoffSecs);
        var h = Math.floor(remain / 3600);
        var m = Math.floor((remain % 3600) / 60);
        var s = remain % 60;
        if (H) H.textContent = pad(h);
        if (M) M.textContent = pad(m);
        if (S) S.textContent = pad(s);
        var when = el.querySelector('[data-bp-cd-when]');
        if (when) when.textContent = beforeCutoff ? 'today' : 'tomorrow';
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---- sticky mobile CTA: show only AFTER the shopper has passed the main
     add-to-cart. This mirrors the Israeli store and avoids covering the first
     mobile viewport while the actual purchase controls are still below it. ---- */
  function initSticky() {
    var bar = document.querySelector('[data-bp-sticky]');
    var heroBtn = document.querySelector('[data-bp-hero-atc]');
    if (!bar || !heroBtn) return;
    document.body.classList.add('bp-has-sticky');
    function update() {
      var r = heroBtn.getBoundingClientRect();
      var on = r.bottom < 0;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('tabindex');
      else bar.setAttribute('tabindex', '-1');
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('pageshow', update);
    window.addEventListener('resize', update, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(update, { threshold: [0, 1] }).observe(heroBtn);
    }
    update();
    setTimeout(update, 400);
    setTimeout(update, 1500);
  }

  /* Removing a mat drops its variant and restores same-size pair parity. The
     existing lines are updated atomically; the cart is never cleared and rebuilt. */
  function initCartRemoveLock() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('cart-remove-button, .cart-remove-button');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!BP.cartState || !BP.cartState.begin()) return;
      var pendingDrawer = document.querySelector('cart-drawer');
      if (pendingDrawer) pendingDrawer.classList.add('bp-cart-busy');
      var idxEl = btn.closest('[data-index]');
      var idx = parseInt((btn.dataset && btn.dataset.index) || (idxEl && idxEl.dataset.index), 10);
      var row = btn.closest('.cart-item, .bp-cd-item');
      var keyedControl = row && row.querySelector('[data-bp-key]');
      var lineKey = btn.dataset.bpKey || (keyedControl && keyedControl.dataset.bpKey);
      var quantityControl = row && row.querySelector('[data-quantity-variant-id]');
      var displayedVariant = quantityControl && quantityControl.dataset.quantityVariantId;
      BP.cartState.read().then(function (cart) {
        var item = lineKey ? (cart.items || []).find(function (it) { return it.key === lineKey; }) : (cart.items || [])[idx - 1];
        if (!item || !item.key || (displayedVariant && String(item.variant_id) !== displayedVariant)) throw new Error('Your cart changed. Please reopen it and try again.');
        if (/-fountain$/.test(item.handle || '')) {
          var updates = {}, remaining = 0, subscriptions = 0;
          updates[item.key] = 0;
          cart.items.forEach(function(it){ if(it.key!==item.key && /-fountain$/.test(it.handle||'')){remaining+=it.quantity;if(!/one-time|fountain only/i.test(it.variant_title||''))subscriptions+=it.quantity;} });
          var kept = {};
          cart.items.forEach(function(it){
            var id=String(it.variant_id), required={ '67828211384637':remaining*2,'67828213317949':subscriptions,'67843590193469':subscriptions,'67828215251261':0 };
            if(Object.prototype.hasOwnProperty.call(required,id)){updates[it.key]=kept[id]?0:required[id];kept[id]=true;}
          });
          return postCart('cart/update.js', { updates: updates });
        }
        if (!isMatItem(item)) return postCart('cart/change.js', { id: item.key, quantity: 0 });
        var byV = variantTotals(cart), order = matOrder(cart), ck = String(item.variant_id);
        if (byV[ck]) byV[ck].qty = 0;
        var bySize = {};
        order.forEach(function (k) { var sz = byV[k].size || 'XL'; bySize[sz] = (bySize[sz] || 0) + byV[k].qty; });
        Object.keys(bySize).forEach(function (sz) {
          if (bySize[sz] % BUNDLE_QTY !== 0) {
            for (var i = 0; i < order.length; i++) {
              var k = order[i];
              if (byV[k].qty > 0 && (byV[k].size || 'XL') === sz) { byV[k].qty -= 1; break; }
            }
          }
        });
        return postCart('cart/update.js', { updates: matLineUpdates(cart, byV) });
      }).then(renderCart).catch(recoverCart).finally(function () {
        if (pendingDrawer) pendingDrawer.classList.remove('bp-cart-busy');
        BP.cartState.end();
      });
    }, true);
  }

  /* ---- order-rules safety net ----
     Self-heals carts that drift out of bounds (permalink edits, console,
     third-party apps). Two rules:
       1. per-SIZE mat count is EVEN (a set is 2 mats of one size) - an odd
          mat is trimmed ("you can only buy the bundle");
       2. TWO SETS PER ORDER - the cart may hold at most two sets (4 mats).
          Extra mats are trimmed while preserving full pairs where possible.
     Runs deferred on page load. */
  function enforceBundleCeiling() {
    if (!BP.cartState || BP.cartState.isBusy() || !BP.cartState.begin()) return;
    var pendingDrawer = null, mutationStarted = false;
    return BP.cartState.read()
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) return;
        /* per-VARIANT totals (the BOGO discount splits sets into two lines) */
        var byV = variantTotals(cart);
        var order = matOrder(cart); // MAT variant ids, cart order
        var changed = false;
        function setQty(k, q) { byV[k].qty = q; changed = true; }
        function trimNewestMatOfSize(sz) {
          for (var i = 0; i < order.length; i++) {
            var k = order[i];
            if (byV[k].qty > 0 && (byV[k].size || 'XL') === sz) { setQty(k, byV[k].qty - 1); return true; }
          }
          return false;
        }
        function trimNewestSet() {
          var sz = null;
          for (var i = 0; i < order.length; i++) {
            if (byV[order[i]].qty > 0) { sz = byV[order[i]].size || 'XL'; break; }
          }
          if (sz == null) return false;
          var removed = 0;
          var guard = 0;
          while (removed < BUNDLE_QTY && guard < 200) {
            guard++;
            if (!trimNewestMatOfSize(sz)) break;
            removed++;
          }
          return removed > 0;
        }
        // rule 1: per-SIZE mat count must be EVEN. A SET is two mats of the SAME
        // SIZE (colors may differ); the per-size automatic discount frees one of
        // each same-size pair. An odd count for a size = one unpaired full-price
        // mat, which we trim ("you can only buy the bundle"). Replaces the old
        // per-VARIANT-even rule, which wrongly deleted a legit two-COLOR pair
        // (each color qty 1).
        function fixParity() {
          var bySize = {};
          order.forEach(function (k) { var s = byV[k].size || 'XL'; bySize[s] = (bySize[s] || 0) + byV[k].qty; });
          Object.keys(bySize).forEach(function (s) { if (bySize[s] % BUNDLE_QTY !== 0) trimNewestMatOfSize(s); });
        }
        fixParity();
        // rule 2: TWO SETS PER ORDER. Mixed sizes are allowed as long as every
        // size remains paired and the cart total stays at four mats or below.
        var totalMats = function () {
          var t = 0; order.forEach(function (k) { t += byV[k].qty; }); return t;
        };
        var guard = 0;
        while (totalMats() > MAX_BUNDLE_MATS && guard < 200) { guard++; if (!trimNewestSet()) break; }
        fixParity();
        if (!changed) return;
        var lineUpdates = matLineUpdates(cart, byV);
        pendingDrawer = document.querySelector('cart-drawer');
        if (pendingDrawer) pendingDrawer.classList.add('bp-cart-busy');
        mutationStarted = true;
        return postCart('cart/update.js', { updates: lineUpdates }).then(renderCart);
      })
      .catch(function (err) { if (mutationStarted) return recoverCart(err); })
      .finally(function () {
        if (pendingDrawer) pendingDrawer.classList.remove('bp-cart-busy');
        BP.cartState.end();
      });
  }
  BP.enforceBundleCeiling = enforceBundleCeiling;

  /* ============================================================
     CART DRAWER - urgency clock, delivery date, upsell rail
     (Pelsbarn clone, 2026-09-02). Markup: snippets/cart-drawer.liquid.
     Everything here is re-render safe: the drawer's innerHTML is swapped
     wholesale by drawer.renderContents(), so nothing binds to a node -
     the paint functions re-query the DOM and the click handler is
     delegated on document.
     ============================================================ */
  var CART_TIMER_KEY = 'bp_cart_timer_end';
  var CART_TIMER_MS = 4 * 60 * 1000; /* Pelsbarn's data-urgency-minutes="4" */

  function readCartDeadline() {
    try { var v = parseInt(sessionStorage.getItem(CART_TIMER_KEY), 10); return isNaN(v) ? 0 : v; }
    catch (e) { return 0; }
  }
  function writeCartDeadline(v) {
    try { sessionStorage.setItem(CART_TIMER_KEY, String(v)); } catch (e) {}
  }
  /* opening the drawer starts the clock, but never shortens a running one */
  function beginCartTimer() {
    var end = readCartDeadline();
    if (!end || end <= Date.now()) writeCartDeadline(Date.now() + CART_TIMER_MS);
    paintCartTimer();
  }
  function restartCartTimer() {
    writeCartDeadline(Date.now() + CART_TIMER_MS);
    paintCartTimer();
  }
  BP.restartCartTimer = restartCartTimer;

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function paintCartTimer() {
    var nodes = document.querySelectorAll('[data-bp-cart-clock]');
    if (!nodes.length) return; /* empty cart / no drawer: nothing to keep alive */
    var end = readCartDeadline();
    var left = end - Date.now();
    /* OWNER RULE (Ram): on expiry we do NOT push anyone to checkout the way
       Pelsbarn does - the clock simply starts over. */
    if (!end || left <= 0) {
      end = Date.now() + CART_TIMER_MS;
      writeCartDeadline(end);
      left = CART_TIMER_MS;
    }
    var s = Math.max(0, Math.ceil(left / 1000));
    var txt = pad2(Math.floor(s / 60)) + ':' + pad2(s % 60);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent !== txt) nodes[i].textContent = txt;
    }
  }

  /* Estimated delivery = today + 8 BUSINESS days (Mon-Fri), i.e. the nearer end of the
     published 8 to 16 business-day transit window. Computed on the America/New_York
     wall-clock date so every visitor sees one date, and rendered the way Pelsbarn does
     it: "Estimated delivery: Wednesday, Sep 16". */
  var ETA_BUSINESS_DAYS = 8;
  var US_WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var US_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function storeToday() {
    var now = new Date();
    try {
      var p = new Intl.DateTimeFormat('en-CA', {
        timeZone: (window.Shopify && Shopify.country === 'AU') ? 'Australia/Sydney' : 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(now).split('-');
      return new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
    } catch (e) {
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    }
  }
  function addBusinessDays(from, days) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    var added = 0, guard = 0;
    while (added < days && guard < 400) {
      guard++;
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++; /* weekends are not business days */
    }
    return d;
  }
  function paintDeliveryEta() {
    var nodes = document.querySelectorAll('[data-bp-eta]');
    if (!nodes.length) return;
    var d = addBusinessDays(storeToday(), ETA_BUSINESS_DAYS);
    var key = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
    var txt = 'Estimated delivery: ' + US_WEEKDAYS[d.getDay()] + ', ' +
      US_MONTHS[d.getMonth()] + ' ' + d.getDate();
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-bp-eta') !== key) {
        nodes[i].textContent = txt;
        nodes[i].setAttribute('data-bp-eta', key);
      }
    }
  }

  /* "Score! You saved $X 🎉" bubble over the button that was just pressed */
  function cartBubble(rect, text) {
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var b = document.createElement('div');
      b.className = 'bp-cd-bubble';
      b.textContent = text;
      b.style.left = Math.round(rect.left + rect.width / 2) + 'px';
      b.style.top = Math.round(rect.top - 6) + 'px';
      document.body.appendChild(b);
      setTimeout(function () { b.classList.add('is-out'); }, 1200);
      setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, 1700);
    } catch (e) {}
  }

  /* Upsell rail: one click = add 1 of that variant, re-render the drawer via
     Section Rendering, restart the clock, celebrate the saving. */
  function initCartUpsell() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('[data-bp-up-add]');
      if (!btn) return;
      var card = btn.closest('[data-bp-up-id]');
      if (!card) return;
      e.preventDefault();
      var vid = parseInt(card.getAttribute('data-bp-up-id'), 10);
      if (!vid) return;
      var save = card.getAttribute('data-bp-up-save') || '';
      var rect = btn.getBoundingClientRect();
      btn.disabled = true;
      btn.classList.add('is-loading');
      var drawer = document.querySelector('cart-drawer');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{ id: vid, quantity: 1 }],
          sections: drawer ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res || (res.status && Number(res.status) >= 400)) throw new Error('add failed');
          restartCartTimer();
          if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
            paintCartTimer();
            paintDeliveryEta();
            if (save) cartBubble(rect, 'Score! You saved ' + save + ' 🎉');
          } else {
            window.location.reload();
          }
        })
        .catch(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          BP.flash("Couldn't add that, please try again");
        });
    }, false);
  }

  /* Start the clock when the drawer opens and repaint after every re-render.
     Patched on the prototype so it covers the header cart icon, the buy-box
     ATC and Dawn's own quantity/remove re-renders alike. */
  function hookCartDrawer() {
    var C = (window.customElements && customElements.get) ? customElements.get('cart-drawer') : null;
    if (C && C.prototype) {
      if (typeof C.prototype.open === 'function' && !C.prototype.bpTimerHook) {
        var openOrig = C.prototype.open;
        C.prototype.open = function () {
          try { beginCartTimer(); paintDeliveryEta(); } catch (e) {}
          return openOrig.apply(this, arguments);
        };
        C.prototype.bpTimerHook = true;
      }
      if (typeof C.prototype.renderContents === 'function' && !C.prototype.bpRenderHook) {
        var renderOrig = C.prototype.renderContents;
        C.prototype.renderContents = function () {
          var out = renderOrig.apply(this, arguments);
          try { paintCartTimer(); paintDeliveryEta(); } catch (e) {}
          return out;
        };
        C.prototype.bpRenderHook = true;
      }
    }
    /* Dawn's quantity path swaps .drawer__inner without touching renderContents,
       so watch the host and repaint whatever comes back. */
    var host = document.getElementById('CartDrawer');
    if (host && window.MutationObserver) {
      new MutationObserver(function () {
        paintCartTimer();
        paintDeliveryEta();
      }).observe(host, { childList: true, subtree: true });
    }
    var icon = document.getElementById('cart-icon-bubble');
    if (icon) icon.addEventListener('click', function () { beginCartTimer(); }, true);
  }

  function initCartUrgency() {
    hookCartDrawer();
    paintCartTimer();
    paintDeliveryEta();
    setInterval(function () {
      paintCartTimer();
      paintDeliveryEta();
    }, 1000);
  }

  function boot() {
    initCountdowns();
    initSticky();
    initCartRemoveLock();
    /* 2026-09-07 (Ram: simpler global cart): the urgency clock, delivery ETA and
       upsell rail are no longer booted. Their markup left snippets/cart-drawer.liquid
       on the same day; the functions above stay so the ATC path's
       restartCartTimer()/paint*() calls remain harmless no-ops. */
    /* Cart-ceiling self-heal runs OFF the critical path. It's a defensive
       safety net for edge-cases (permalink exploit, third-party app drift),
       not a primary code path, so we shouldn't pay its network round-trip
       on first paint. requestIdleCallback runs it when the browser is idle;
       fallback to a 1.5s setTimeout for browsers without rIC. */
    var deferredCeiling = function () { enforceBundleCeiling(); };
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(deferredCeiling, { timeout: 3000 });
    } else {
      setTimeout(deferredCeiling, 1500);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();

